export default {
    kiutr: 'Пассажирские перевозки',
    road: 'Обслуживание дорог',
    communal: 'Коммунальные работы',
    children: 'Перевозка детей',
    garbage: 'Вывоз мусора',
};


// WEBPACK FOOTER //
// ./src/dictionaries/systems.js